export default {
  ENABLE_LOCATION_SERVICES: `You must enable location services in your device's settings.`,
  ALLOW_ACCESS: {
    TITLE: `Allow Merinio to access your location`,
    SUMMARY: `This allows your location to be added to your punch card.`,
    USE_TITLE: `How we use this information`,
    USE_CONTENT: `We use this information to confirm that your location matches the shift location.`,
    CONTROL_TITLE: `How you control this`,
    CONTROL_CONTENT: `You can change this anytime in your device settings.`,
    ALLOW: `Allow`,
    DONT_ALLOW: `Don't allow`
  },
  CONFIRM_ACCESS: {
    TITLE: `Are you sure?`,
    SUMMARY: `You did not allow Merinio to access your location.`,
    CONTENT: `Without this information we cannot confirm if your location matches the location of your shift.`,
    SHARE: `Share my location`,
    DONT_SHARE: `Don't share my location`
  },
  PUNCH_IN: `Punch in`,
  PUNCHED_IN: `Punched in`,
  PUNCH_OUT: `Punch out`,
  PUNCHED_OUT: `Punched out`,
  APPROVED_TIME: `approved`,
  APPROVED_TIME_WEEK: `Your approved time for this week is {{weekPaidHours}}.`,
  START_BREAK: `Start break`,
  END_BREAK: `End break`,
  TRANSFER: `Transfer to another position`,
  TRANSFER_PROJECT: `Transfer to another project`,
  TRANSFERS: `Transfers`,
  PUNCH_OPTIONS: `Punch options`,
  WRONG_DAY: `Warning, this shift is not today!`,
  CUSTOM_BREAK: `Unplanned break`,
  STATUSES: {
    UNPUNCHED: `Unpunched`,
    APPROVED: `Approved`,
    NEEDS_APPROVAL: `Pending approval`,
    NOT_PUNCHED_OUT: `Missing punch out`,
    LOCATION_CONFLICTS: `Punch location conflicts`
  },
  notifications: {
    PUNCHED_IN: { title: `Punched in`, description: `You have successfully punched in.` },
    PUNCHED_OUT: { title: `Punched out`, description: `You have successfully punched out.` },
    TRANSFERRED: { title: `Transferred`, description: `You have successfully transferred.` },
    STARTED_BREAK: { title: `Break started`, description: `You have successfully started your break.` },
    ENDED_BREAK: { title: `Break ended`, description: `You have successfully ended your break.` }
  },
  PUNCH_IN_MODAL: {
    TITLE: `Punch in`,
    SUMMARY: `Are you sure you want to punch in?`
  },
  PUNCH_OUT_MODAL: {
    TITLE: `Punch out`,
    SUMMARY: `Are you sure you want to punch out?`
  },
  PUNCH_ADD_COMMENT_MODAL: {
    TITLE: `Add a comment`,
    SUMMARY: ``
  },
  LATEARRIVALCOMMENT: `You are punching in {{lateArrival}} late, you can add a comment for your manager below.`,
  EARLYDEPARTURECOMMENT: `You are punching out {{earlyDeparture}} early, you can add a comment for your manager below.`,
  EARLYARRIVALCOMMENT: `You are punching in {{earlyArrival}} early, you can add a comment for your manager below.`,
  LATEDEPARTURECOMMENT: `You are punching out {{lateDeparture}} late, you can add a comment for your manager below.`,
  TRANSFERPOSITIONCOMMENT: `You are transfering to another position. You can add a comment for your manager below.`,
  TRANSFERPROJECTCOMMENT: `You are transfering to another project. You can add a comment for your manager below.`,
  COMMENT: {
    LABEL: ``,
    PLACEHOLDER: `Add a comment`,
    DESCRIPTION: ``
  },
  TRANSFER_MODAL: {
    TITLE: `Transfer`,
    SUMMARY: ``,
    TRAINED: `Trained`,
    NOT_TRAINED: `Not trained`
  },
  TRANSFER_PROJECT_MODAL: {
    TITLE: `Transfer to another project`,
    SUMMARY: ``
  },
  POSITIONID: {
    LABEL: `Transfer to position`,
    DESCRIPTION: `Select the position to which you are punching a transfer.`
  },
  PROJECTID: {
    LABEL: `Transfer to project`,
    DESCRIPTION: `Select the project to which you are punching a transfer.`
  },
  CUSTOMBREAKREASON: {
    LABEL: `Reason`,
    PLACEHOLDER: `Why are you taking this unplanned break?`,
    DESCRIPTION: ``
  },
  BREAK_START_MODAL: {
    TITLE: `Take break`,
    SUMMARY: ``,
    BREAKS_IN_SHIFT: `Breaks in shift`,
    OTHER_BREAKS: `Other breaks`
  },
  BREAK_END_MODAL: {
    TITLE: `End break`,
    SUMMARY: `Are you sure you want to end your break?`
  },
  SELECTEDBREAK: {
    LABEL: `Break type to take`,
    DESCRIPTION: `Choose the break you would like to take.`
  }
}
